import { createApiClient } from "./client";

export const loginUser = async ({ email, password }) => {
  const client = createApiClient();
  const response = await client.post("/login/user", { email, password });
  return response.data;
};

export const getCurrentUser = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/self");
  return response.data;
};

export const updateCurrentUser = async (token, payload) => {
  const client = createApiClient(token);
  const response = await client.put("/user/self", payload);
  return response.data;
};

export const getBootstrapStatus = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/budget-portal/bootstrap-status");
  return response.data;
};

export const getAvailableBackups = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/budget-portal/backups");
  return response.data;
};

export const importLatestBackup = async (token) => {
  const client = createApiClient(token);
  const response = await client.post("/user/budget-portal/bootstrap-import", {});
  return response.data;
};

export const restoreBudgetPortalBackup = async (token, backupPath) => {
  const client = createApiClient(token);
  const response = await client.post("/user/budget-portal/restore-backup", {
    backup_path: backupPath,
  });
  return response.data;
};

export const getMappingState = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/budget-portal/mapping-state");
  return response.data;
};

export const saveExcelToViMapping = async (token, mapping) => {
  const client = createApiClient(token);
  const response = await client.put("/user/budget-portal/mapping-state/excel-to-vi", {
    excel_to_vi_description_mapping: mapping,
  });
  return response.data;
};

export const getYearCards = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/budget-portal/year-cards");
  return response.data;
};

export const getWorkspace = async (token, year) => {
  const client = createApiClient(token);
  const response = await client.get(`/user/budget-portal/workspace/${year}`);
  return response.data;
};

export const saveWorkspace = async (token, year, payload) => {
  const client = createApiClient(token);
  const response = await client.put(`/user/budget-portal/workspace/${year}`, payload);
  return response.data;
};

export const getChangeRequests = async (token, year) => {
  const client = createApiClient(token);
  const response = await client.get("/user/budget-portal/change-requests", {
    params: { year },
  });
  return response.data;
};

export const createChangeRequest = async (token, payload) => {
  const client = createApiClient(token);
  const response = await client.post("/user/budget-portal/change-requests", payload);
  return response.data;
};

export const withdrawChangeRequest = async (token, requestId) => {
  const client = createApiClient(token);
  const response = await client.post(
    `/user/budget-portal/change-requests/${requestId}/withdraw`,
    {},
  );
  return response.data;
};

export const respondChangeRequest = async (token, requestId, action, remark) => {
  const client = createApiClient(token);
  const response = await client.post(
    `/user/budget-portal/change-requests/${requestId}/respond`,
    { action, remark },
  );
  return response.data;
};

export const assignDepartmentPerson = async (token, year, payload) => {
  const client = createApiClient(token);
  const response = await client.post(
    `/user/budget-portal/workspace/${year}/department-assignments`,
    payload,
  );
  return response.data;
};

export const updateDepartmentPerson = async (
  token,
  year,
  assignmentUserId,
  payload,
) => {
  const client = createApiClient(token);
  const response = await client.put(
    `/user/budget-portal/workspace/${year}/department-assignments/${assignmentUserId}`,
    payload,
  );
  return response.data;
};

export const removeDepartmentPerson = async (token, year, assignmentUserId) => {
  const client = createApiClient(token);
  const response = await client.delete(
    `/user/budget-portal/workspace/${year}/department-assignments/${assignmentUserId}`,
  );
  return response.data;
};

export const getReferenceData = async (token) => {
  const client = createApiClient(token);
  const response = await client.get("/user/countries");
  return response.data;
};
